import React from "react";
import { pushCtaOmniEvents } from '../../../../utils/PushEvents/Omniture/clickEvents'
import { CTA_TYPE } from '../../../../utils/PushEvents/Omniture/utils'
import { signIn } from "../../.../../../../containers/Common/Utils";
import Icon from "../../../../../../../bus-dweb/src/stories/core-components/IconsSelector";
import * as S from './GoDeals.styles';

const onClickHelper = (e)  => {
    pushCtaOmniEvents('Login_banner_selected',CTA_TYPE.HYPER_LINK, 'Card_header', 'Home'); 
    e.stopPropagation(); 
    signIn();
}

const GoDeals = ({ persuasion }) => {
    const goDealsIcon = "https://gos3.ibcdn.com/goDeals_icon-1655378843.png"
    const { heading, title, text } = persuasion;

    return (
        <S.DealSection>
            <S.GoDeals onClick={onClickHelper} >
                <S.ImgSection>
                    <img className="goDealsIcon" src={goDealsIcon} />
                    <span className="goDealTxt">{text}</span>
                </S.ImgSection>
                <S.LoginSection>{heading}
                    <Icon name="ArrowRight" styleProps={{ fill: '#148730', width: '8px', height: '8px' }}></Icon>
                </S.LoginSection>
            </S.GoDeals>
        </S.DealSection>
    );
};

export default GoDeals;
